import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const Details = ({ config, onNext, onBack, editMode }) => {
  const { t } = useTranslation(['create-event', 'common'])
  return (
    <div className="event-content">
      <div className="inputs-wrapper">
        <div className="event-header">{config.header}</div>
        {(config.inputs.first || config.inputs.second) && (
          <div className="input-row">
            {config.inputs.first && (
              <div className="input-container">
                <div className="input-label">{config.inputs.first.label}</div>
                {config.inputs.first.render()}
              </div>
            )}
            {config.inputs.second && (
              <div className="input-container">
                <div className="input-label">{config.inputs.second.label}</div>
                {config.inputs.second.render()}
              </div>
            )}
          </div>
        )}
        {(config.inputs.third || config.inputs.fourth) && (
          <div className="input-row">
            {config.inputs.third && (
              <div className="input-container">
                <div className="input-label">{config.inputs.third.label}</div>
                {config.inputs.third.render()}
              </div>
            )}
            {config.inputs.fourth && (
              <div className="input-container">
                <div className="input-label">{config.inputs.fourth.label}</div>
                {config.inputs.fourth.render()}
              </div>
            )}
          </div>
        )}
        <div className="input-row">
          {config.inputs.fifth && (
            <div className="input-container">
              <div className="input-label">{config.inputs.fifth.label}</div>
              {config.inputs.fifth.render()}
            </div>
          )}
        </div>
        <div className="input-row">
          {config.inputs.sixth && (
            <div className="input-container">
              <div className="input-label">{config.inputs.sixth.label}</div>
              {config.inputs.sixth.render()}
            </div>
          )}
        </div>
      </div>

      {!editMode && (
        <div className="event-footer">
          <button className="button button-grey" onClick={onBack}>
            {t('common:actions.cancel')}
          </button>
          <button className="button button-primary" disabled={!config.canGoNext} onClick={onNext}>
            {t('create-event:shared.next')}
          </button>
        </div>
      )}
    </div>
  )
}

Details.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  config: PropTypes.object,
  editMode: PropTypes.bool,
}

export default Details
